import React from 'react'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import { LocaleContext } from '../i18n'
import PageContext from '../components/pageContext'

function SEO({ description, lang, meta, keywords, title, path }) {
  return <StaticQuery
    query={detailsQuery}
    render={data => {
      const pageTitle = title || data.site.siteMetadata.title;
      const metaDescription = description || data.site.siteMetadata.description;
      const metaKeywords = keywords.length ? keywords : data.site.siteMetadata.keywords;

      return (
        <PageContext.Consumer>{({ originalPath }) => {
          return <LocaleContext.Consumer>{({ t }) => {
            const path = originalPath !== '/'
              ? `| ${t((originalPath || '').replace(/\//g, ''))}`
              : ``
            return <Helmet
              htmlAttributes={{
                lang,
              }}
              title={pageTitle}
              titleTemplate={`%s ${path}`}
              meta={[
                {
                  name: `description`,
                  content: metaDescription,
                },
                {
                  property: `og:title`,
                  content: pageTitle,
                },
                {
                  property: `og:description`,
                  content: metaDescription,
                },
                {
                  property: `og:type`,
                  content: `website`,
                },
              ]
                .concat(
                  metaKeywords.length > 0
                    ? {
                      name: `keywords`,
                      content: metaKeywords.join(`, `),
                    }
                    : [],
                )
                .concat(meta)}
            />
          }
          }</LocaleContext.Consumer>
        }
        }</PageContext.Consumer>
      )
    }} />
};

SEO.defaultProps = {
  title: '',
  meta: [],
  keywords: [],
}

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
        site {
      siteMetadata {
        title
        description
      author {
        name
      }
      keywords
    }
  }
}
`;